import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail, Phone } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    // Terapkan font-body (Inter) sebagai base font
    <footer className="bg-[var(--army-green)] text-neutral-200 font-body">
      {/* Menambah padding vertikal untuk kesan lebih premium */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          
          {/* Brand Section */}
          <div>
            {/* Terapkan font-heading (Poppins) */}
            <h3 className="text-2xl font-bold font-heading mb-4" style={{ color: 'var(--caramel)' }}>
              Marajaki Kreatif
            </h3>
            {/* Menggunakan neutral-300 untuk kontras yang lebih baik */}
            <p className="text-sm text-neutral-300 leading-relaxed">
              Transforming Dayak ritual heritage into modern fashion and art. 
              Preserving culture through innovation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            {/* Terapkan font-heading (Poppins) */}
            <h4 className="text-lg font-semibold font-heading mb-4" style={{ color: 'var(--arylide-yellow)' }}>
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200">
                  About
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200">
                  Our Products
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            {/* Terapkan font-heading (Poppins) */}
            <h4 className="text-lg font-semibold font-heading mb-4" style={{ color: 'var(--arylide-yellow)' }}>
              Connect With Us
            </h4>
            <div className="space-y-3">
              <a
                href="https://www.instagram.com/marajaki.kreatif"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200 group"
              >
                <Instagram className="w-4 h-4" />
                {/* Menambah underline on hover untuk interaksi yang lebih jelas */}
                <span className="group-hover:underline">@marajaki.kreatif</span>
              </a>
              <a
                href="mailto:bennaurel@gmail.com"
                className="flex items-center space-x-2 text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200 group"
              >
                <Mail className="w-4 h-4" />
                <span className="group-hover:underline">bennaurel@gmail.com</span>
              </a>
              <a
                href="https://wa.me/6282154433065"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 text-sm text-neutral-300 hover:text-[var(--caramel)] transition-colors duration-200 group"
              >
                <Phone className="w-4 h-4" />
                <span className="group-hover:underline">+62 821-5443-3065</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        {/* Mengganti border-gray-600 menjadi border-white/20 agar lebih soft */}
        <div className="pt-8 border-t border-white/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-neutral-400">
              © {currentYear} Marajaki Kreatif. All Rights Reserved.
            </p>
            <p className="text-sm text-neutral-400">
              Developed by{' '}
              <a
                href="https://instagram.com/dandisubhani_" // Ganti dengan link Anda
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold transition-colors duration-200 hover:text-white"
                style={{ color: 'var(--caramel)' }}
              >
                dandisubhani
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};